export default function PHP_asin() {
  return (
    <div>
      <h1>PHP_asin</h1>
    </div>
  );
}
